<script lang="ts">
  import PageWrapper from "@src/components/PageWrapper.svelte";
  import Row from "@src/components/Row.svelte";
</script>

<svelte:head>
  <title>Niilon Pojat - Sivua ei löytynyt</title>
</svelte:head>
<PageWrapper fillerColor="gray">
  <Row color="yellow">
    <p>TODO: 404 sivu</p>
  </Row>
  <Row color="gray" filler />
</PageWrapper>
